import React from "react";
import "../DesignerPropertiesPanel.css";

const ButtonProperties = ({
  selectedObject,
  latestTags,
  updateObjectDataField,
}) => {
  const dataJson = selectedObject.data_json || {};

  return (
    <div className="dp-section">
      <h4 className="dp-section-title">Content</h4>

      <div className="dp-field">
        <label className="dp-label">Label</label>
        <input
          type="text"
          value={dataJson.label || ""}
          onChange={(e) =>
            updateObjectDataField(selectedObject.id, "label", e.target.value)
          }
          className="dp-input"
        />
      </div>

      <div className="dp-field">
        <label className="dp-label">Action Type</label>
        <select
          value={dataJson.action_type || "tag_write"}
          onChange={(e) =>
            updateObjectDataField(selectedObject.id, "action_type", e.target.value)
          }
          className="dp-select"
        >
          <option value="tag_write">Real Tag Write</option>
          <option value="link">Open Link</option>
        </select>
      </div>

      {(dataJson.action_type || "tag_write") === "tag_write" && (
        <>
          <div className="dp-field">
            <label className="dp-label">Real Tag Name</label>
            <select
              value={dataJson.tag_name || ""}
              onChange={(e) =>
                updateObjectDataField(selectedObject.id, "tag_name", e.target.value)
              }
              className="dp-select"
            >
              <option value="">Select real tag</option>
              {(latestTags || []).map((tag) => (
                <option key={tag.tag_name} value={tag.tag_name}>
                  {tag.tag_name}
                </option>
              ))}
            </select>
          </div>

          <div className="dp-field">
            <label className="dp-label">Write Value</label>
            <select
              value={String(dataJson.write_value ?? "1")}
              onChange={(e) =>
                updateObjectDataField(
                  selectedObject.id,
                  "write_value",
                  Number(e.target.value)
                )
              }
              className="dp-select"
            >
              <option value="1">Set / ON / 1</option>
              <option value="0">Reset / OFF / 0</option>
            </select>
          </div>
        </>
      )}

      {(dataJson.action_type || "tag_write") === "link" && (
        <>
          <div className="dp-field">
            <label className="dp-label">URL</label>
            <input
              type="text"
              value={dataJson.url || ""}
              onChange={(e) =>
                updateObjectDataField(selectedObject.id, "url", e.target.value)
              }
              placeholder="https://example.com"
              className="dp-input"
            />
          </div>

          <div className="dp-field">
            <label className="dp-checkbox-label">
              <input
                type="checkbox"
                checked={dataJson.open_in_new_tab ?? true}
                onChange={(e) =>
                  updateObjectDataField(
                    selectedObject.id,
                    "open_in_new_tab",
                    e.target.checked
                  )
                }
              />
              Open in new tab
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default ButtonProperties;